import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import Text, { Small, H3, H5 } from '@dbk/ui-text';
import { View } from '@dbk/ui-react-utils';
import {
  VASCO_MODAL_TYPES,
  VASCO_API_ERROR_CODES,
  PALETTE,
  FORGOT_PASSWORD_FLOW_STEPS
} from '../../../../../../src/constants';
import { SuccessIcon } from '../../../../../../src/components/common/icons/index';
import VascoLock from '../../../../../../src/screens/auth/vasco/vasco-lock';

const MAX_VS = 8;
const counter = 0;
let incorrect = false

class VascoOTP extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      vascoToken: '',
      isLoading: false,
      errorTxt: '',
      maskedToken: '',
      userLocked: false,
    };
    this.handleValidateToken = this.handleValidateToken.bind(this);
    this.handleTokenChange = this.handleTokenChange.bind(this);
    this.handleSubmitToken = this.handleSubmitToken.bind(this);
  }
  componentDidMount() {
    if (document.querySelector('div.resetPwdOTP')) {  // reset password OTP screen focus
      document.querySelector('div.resetPwdOTP').focus()
    }
    // if (this.props.vascoauthentication.otpVerified && this.props.vascoauthentication.vascoAuthorised) {
    //   // API call to send new temp password to user’s email
    //   this.props.forgotPassword.generateTemporaryPwd();
    // }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { vascoToken, isLoading } = this.state;
    const { i18n: { messages }, vascoauthentication: { otpStatus, statusCode } } = this.props;
    if (prevProps.otpStatus !== otpStatus) {
      if (otpStatus === false) {
        // if (incorrect) {
        //   this.props.setOTPStatus(undefined);
        //   this.props.setOTPStatuscode(undefined);
        //   this.setState({ isLoading: false, errorTxt: messages['app.vasco.error.invalid'], vascoToken:''});
        // }
        if ((statusCode === VASCO_API_ERROR_CODES.otpIncorrect || statusCode === VASCO_API_ERROR_CODES.otpReplay) && !incorrect) {
          await this.props.setOTPStatus(undefined);
          await this.props.setOTPStatuscode(undefined);
          incorrect = true;
          this.setState({ isLoading: false, errorTxt: messages['app.vasco.error.invalid'], vascoToken:''});
        } else if (statusCode === VASCO_API_ERROR_CODES.userLocked) {
          this.setState({ isLoading: false, errorTxt: '', vascoToken:'', userLocked: true});
        } else if (statusCode === VASCO_API_ERROR_CODES.invalidSession) {
          this.props.setOTPStatus(undefined);
          this.props.setOTPStatuscode(undefined);
          incorrect = true;
          this.setState({ isLoading: false, errorTxt: messages['app.auth.logoutExpireSuccess.text'] });
          this.props.auth.logout();
        }
      }
    }
    if (prevProps.forgotPassword.verifyOTPForForgotPasswordSuccess !== this.props.forgotPassword.verifyOTPForForgotPasswordSuccess &&
      this.props.forgotPassword.verifyOTPForForgotPasswordSuccess) {
      // API call to generate and send new temprorary password to user’s email
      this.props.forgotPassword.generateTempPassword(this.props.auth.userId, this.props.auth.emailId);
    }
    if (document.querySelector('div.resetPwdSuccessFocus')) { // reset password success screen focus
      document.querySelector('div.resetPwdSuccessFocus').focus();
    }
  }

  handleValidateToken() {
    const {
      i18n: { messages },
    } = this.props;
    const { vascoToken, isLoading } = this.state;
    this.setState({ isLoading: true, errorTxt: '' });
    incorrect = false;
    const vascoOTP = vascoToken;
    const isnum = /^\d+$/.test(vascoOTP);

    if (isnum || vascoOTP === '') {
      if (vascoOTP.length < 8 || vascoOTP.length > 8) {
        this.setState({
          isLoading: false,
          errorTxt: messages['app.vasco.error.minLength'],
          vascoToken:''
        });
      } else {
        if (vascoOTP === '00000000') {
          this.setState({
            isLoading: false,
            errorTxt: messages['app.vasco.error.allZeros'],
            vascoToken:''
          });
          if(document.querySelector('.otp-error')){ 
            document.querySelector('.otp-error').focus();
          }
          return;
        }
        this.routePage(vascoOTP);
      }
    } else {
      this.setState({
        isLoading: false,
        errorTxt: messages['app.vasco.error.nonNumeric'],
        vascoToken:''
      });
    }
    if(document.querySelector('.otp-error')){ 
      document.querySelector('.otp-error').focus();
    }
  }

  routePage(vascoOTP) {
 
      setTimeout(() => {
        this.props.onValidateToken(vascoOTP);
      }, 1000);
  }

  handleSubmitToken(event) {
    const {
      nativeEvent: { key },
    } = event;
    if (key == 'Enter' && this.props.vascoauthentication.countDown === null) {
      this.handleValidateToken();
    }
  }

  handleUpdateActivationStatus() {
    this.setState({ isLoading: false, errorTxt: '' });
    // this.props.updateActivationStatus(VASCO_STATUSES.pinError, false);
  }

  navigateToCreatePwd = () => {
      this.props.forgotPassword.setShowCurrentStep(FORGOT_PASSWORD_FLOW_STEPS[2]);
  }

  handleTokenChange(event) {
    const value = event.target.value.toString();
    this.setState({ vascoToken: value });
    // WMCE-7106 Commenting below code for revisit
    // let newVascoToken = '';
    // const value = event.target.value.toString();
    // const vascoField = document.getElementById('vascotoken');
    // const startPosition = vascoField.selectionStart;
    // const endPosition = vascoField.selectionEnd;
    // const lastRecord = value.slice(value.length - 1);

    // if(this.state.vascoToken.length < value.length && !isNaN(parseInt(lastRecord))){
    //   newVascoToken = `${this.state.vascoToken}${lastRecord}`;
    // } else if(this.state.vascoToken.length > value.length && isNaN(parseInt(lastRecord)) && value.length === startPosition && value.length === endPosition){
    //   newVascoToken = this.state.vascoToken.slice(0, - 1);
    // } else {
    //   newVascoToken = this.state.vascoToken.slice(0,startPosition) + this.state.vascoToken.slice(startPosition+1);
    // }
    // this.setState({ vascoToken: newVascoToken, maskedToken: DOT_UNICODE.repeat(value.length)});
  }

  render() {
    const { vascoToken, isLoading } = this.state;
    const {
      i18n: { messages },
      vascoauthentication: { otpStatus, statusCode },
      forgotPassword: {  generateTempPasswordResponse, generateTempPwdResultValid }
    } = this.props;

    if(this.state.userLocked){
      return <VascoLock instructionsMsgId="app.vasco.ch.instructions.exceeded"/>
    }

    if (generateTempPasswordResponse !== null && generateTempPwdResultValid === true) {
      return (

        <View className="padding-right-70">
          <H3 className="resetPwdSuccessFocus" tabIndex={0} aria-label={messages['app.forgotPassword.title.resetPassword']}>
              {messages['app.forgotPassword.title.resetPassword']}
            <SuccessIcon className="margin-left-20" color={PALETTE.successIcon} height={24} width={24} />
          </H3>
          <Text size="big" className="margin-top-10" tabIndex={0} aria-label={messages['app.forgotPassword.tempPasswordMessage']}>
            {messages['app.forgotPassword.tempPasswordMessage']}
          </Text>
          <View className="text-center pad-top-70">
            <Button fullWidth size='large'
              onPress={this.navigateToCreatePwd}
            >
              {messages['app.terms.acceptContinue']}
            </Button>
          </View>
        </View>
      )
    }

    // if (isLoading && !this.props.vascoauthentication.otpStatus) {
    //   return (
    //     <LoadingCircle noPadding isPage={false} />
    //   )
    // }
      return (
      <View>
        <View className="padding-right-70">
                <View>
                  <View>
                    <View className="large-12 instructions-block instruction-border">
                    <H3 className="pad-top-bottom-10 resetPwdOTP" tabIndex={0} aria-label={messages['app.vasco.ch.web.title.otp']}>
                        {messages['app.vasco.ch.web.title.otp']}
                      </H3>
                      <View className="text--primary pad-bottom-20 margin-top-20 ">
                        <H5 tabIndex={0} aria-label={messages['app.vasco.ch.instructions.main']}>
                          {messages['app.vasco.ch.instructions.main']}
                        </H5>
                      </View>

                      <View className="numbering">
                        <View className="font-size-30">1</View>
                        <Text className="text-left padding-left-15" tabIndex={0} aria-label={`Step1: ${messages['app.vasco.instructions.step1']}`}>
                          {messages['app.vasco.instructions.step1']}
                        </Text> 
                      </View>  

                      <View className="numbering">
                        <View className="font-size-30">2</View>
                        <Text className="text-left padding-left-15" tabIndex={0} aria-label={`Step2: ${messages['app.vasco.instructions.step2']}`}>
                          {messages['app.vasco.instructions.step2']}
                        </Text> 
                      </View>

                      <View className="numbering">
                        <View className="font-size-30">3</View>
                        <Text className="text-left padding-left-15" tabIndex={0} aria-label={`Step3: ${messages['app.vasco.instructions.step3']}`}>
                          {messages['app.vasco.instructions.step3']}
                        </Text> 
                      </View>
                              
                    </View>
                  </View>

                  <View className="row">
                    <View>
                      <View className="pad-top-20">
                          {/* {messages['app.vasco.instructions.inputLabel']} */}
                      </View>
                      <View className="text-center otp-error" tabIndex={this.state.errorTxt !== '' ? "0" :"-1"} aria-label={this.state.errorTxt+messages['app.vasco.rasp.alert']}>
                          <Small style={{ color: 'red' }}>
                            {this.state.errorTxt}
                          </Small> 
                        </View>
                      <View className="pad-bottom-40">
                        <TextInput
                          label=  {messages['app.vasco.instructions.inputLabel']}
                          disabled={ this.props.vascoauthentication.countDown !== null }
                          aria-label={messages['app.accessibility.forgotPwd.otp']}
                          textID="input-userId"
                          name="userId"
                          maxLength={8}
                          type="password"
                          value={this.state.vascoToken}
                          id="vascotoken"
                          onChange={(event) => this.handleTokenChange(event)}
                          onKeyPress={(event) => this.handleSubmitToken(event)}
                          ref="vascoToken"
                          autoComplete="new-password"
                          letterSpacing={10}
                          className="rsaBox"
                          size="large"
                          // style={{ textAlign: 'center', width: '70%' }}
                        />
                      </View>
                  <View id="btn_validateOtp_vasco">
                    <Button
                      size="large"
                      testID='btn_validate_otp_vasco'
                      loading={isLoading && !this.props.vascoauthentication.otpStatus}
                      fullWidth onPress={this.handleValidateToken}
                      disabled={this.props.vascoauthentication.countDown > 0}>
                      {this.props.vascoauthentication.countDown > 0 ? (messages['app.vasco.validate.token.waitButton'] + ` (${this.props.vascoauthentication.countDown})`) : messages['app.vasco.validate.token.button']}
                    </Button>
                  </View>
                    </View>
                  </View>
                </View>
        </View>
        </View>
      );



  }
}

VascoOTP.propTypes = {};

export default createContainer({
  $queries: {
    onValidateToken: {
      $call: 'vascoauthentication.validateVascoPwd',
    },
    updateActivationStatus: {
      $call: 'vascoauthentication.updateActivationStatus',
    },
    setVascoModalType: {
      $call: 'vascoauthentication.setVascoModalType',
    },
    vascoauthentication: {
      otpStatus: true,
      statusCode: true,
      vascoAuthorised: true,
      countDown: true
    },
    setOTPStatus: {
      $call: 'vascoauthentication.setOTPStatus',
    },
    setOTPStatuscode: {
      $call: 'vascoauthentication.setOTPStatuscode',
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      logout: { $call: 'logout' },
      userId: true,
      emailId: true
    },
    hrmw: {
      signContact: { $call: 'signContact' },
      isManageContactDetails : true
    },
    forgotPassword: {
      generateTempPassword: { $call: 'generateTempPassword' },
      verifyOTPForForgotPasswordSuccess: true,
      generateTempPwdResultValid: true,
      generateTempPasswordResponse: true,
      setShowCurrentStep: { $set: 'showCurrentStep'}
    },
  },
})(VascoOTP);
